module.exports = __webpack_public_path__ + "static/media/lam-lanh-nhanh.1cef235b.svg";